import React from "react";
import { ICharts } from "@Types/kindSumReport";

export const Title = ({ title }) => {
  return (
    <div className='flex items-center justify-center mb-20'>
      <img src='https://photo.8891.com.tw/2024/06/18/1718677242396031.png' alt='' className='w-30 h-20' />
      <p className='text-[#3264FF] text-20 mx-10 font-medium'>{title}</p>
      <img src='https://photo.8891.com.tw/2024/06/18/1718677242382059.png' alt='' className='w-30 h-20' />
    </div>
  );
};

export const TextBox = ({ text }) => {
  return <div className='flex items-center justify-center text-[#3264FF] text-12 h-24 bg-[#EAEFFF]'>{text}</div>;
};

export const initSzieForScale = (num: number) => {
  const initNum = 276;
  const oWidth = 276;
  const rate = oWidth / initNum;

  return num * rate;
};

export const ChartExtraBar = ({ dataSource }) => {
  return (
    <div>
      {dataSource.map((item, inx) => (
        <div className={"pl-8 mt-10 mb-6"} key={inx}>
          <div className='flex leading-18 text-[#333333] text-12 items-center mb-2'>
            <div className='w-12 h-12 bg-[#3264FF] mr-4'></div>
            {item.name}
          </div>
          {item.value && (
            <div className='pl-14 leading-18'>
              <span className='text-[#999999]'>實測環境：</span>
              {item.value}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export const HeroRanking = ({ data, rankKey, href }) => {
  if (!data || !data[rankKey]) return null;

  const { name, rank } = data[rankKey];

  return (
    <h3 className='flex items-center justify-center'>
      <img className='w-36 h-14 mr-8' src='https://photo.8891.com.tw/2023/09/14/1694683760349603.png' alt='' />
      <p className='text-[#333333] text-12 mr-8 font-normal'>
        {name}第{rank}名
      </p>
      <a className='text-[#333333] text-12 font-normal' href={href} target="_blank">
        更多&gt;
      </a>
    </h3>
  );
};

export const ChartExtraListBar = ({ dataSource }) => {
  return (
    <div>
      {dataSource.map((item, inx) => (
        <div className={"mt-10 pl-8"} key={inx}>
          <div className='flex leading-18 text-[#333333] text-12 items-center mb-12'>
            <div className='w-12 h-12 bg-[#3264FF] mr-4'></div>
            {item.title}
          </div>
          {item.environment && (
            <div className='pl-14 leading-18 mb-8'>
              <span className='text-[#999999]'>實測環境:</span>
              {item.environment}
            </div>
          )}
          {item.tirePressure && (
            <div className='pl-14 leading-18 mb-8'>
              <span className='text-[#999999]'>胎壓:</span>
              {item.tirePressure}
            </div>
          )}
          {item.bureauEnergyData && (
            <div className='pl-14 leading-18 mb-8'>
              <span className='text-[#999999]'>能源局數據:</span>
              {item.bureauEnergyData}
            </div>
          )}
          {item.avgYearEnergyConsumption && (
            <div className='pl-14 leading-18 mb-6'>
              <span className='text-[#999999]'>平均燃油費預計:</span>
              {item.avgYearEnergyConsumption}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export const validateData = (data: any, key: number):any => {
  if (data?.[key] && data?.[key]?.chartData && data?.[key]?.chartData.length !== 0) {
    return data?.[key] as ICharts;
  }
  return false;
};

export const formartChartText = (arr: any[]) => {
  if (!Array.isArray(arr) || (arr && arr.length === 0)) return [];
  const data = arr.map((item) => item?.value);
  if (data.length > 0) {
    const textArr: any = [];
    for (let i = 0; i < data[0].length; i++) {
      let tmp: any = [];
      for (let j = 0; j < arr.length; j++) {
        tmp.push(data[j][i]);
      }
      textArr.push(tmp);
    }
    return textArr;
  }
  return [];
};
